import { ApplicationConfig } from '@angular/core';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideRouter } from '@angular/router';
import { networkInterceptor } from './core/interceptors/network.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), //, withDebugTracing()
    //provideClientHydration(), 
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor, networkInterceptor])), 
    provideAnimations(), 
    provideAnimationsAsync()
  ]
};
